import Login from '@/views/auth/Login';
import ForgotPassword from '@/views/auth/ForgotPassword';
import ResetPassword from '@/views/auth/ResetPassword';
import ChangeRepeatedEmail from '@/views/auth/ChangeRepeatedEmail';
import EnterpriseDocuments from '@/views/document/EnterpriseDocuments';
import ProductDocuments from '@/views/document/ProductDocuments';
import SyndicDocuments from '@/views/document/SyndicDocuments';
import FinancialPosition from '@/views/financial/FinancialPosition';
import TicketForm from '@/views/support/ticket/TicketForm';
import TicketList from '@/views/support/ticket/TicketList';
import TicketDetails from '@/views/support/ticket/TicketDetails';
import OmbudsmanForm from '@/views/support/ticket/OmbudsmanForm';
import KeyDeliverySchedule from '@/views/support/schedule/KeyDeliverySchedule';
import AppointmentDetail from '@/views/support/ticket/technicalAssistance/AppointmentDetail';
import MyEnterprise from '@/views/product/MyEnterprise';
import MyDecorated from '@/views/product/MyDecorated';
import ConstructionProgress from '@/views/product/ConstructionProgress';
import DiscountList from '@/views/product/DiscountList';
import Faq from '@/views/support/Faq';
import IncomeReport from '@/views/financial/IncomeReport';
import ToExpirePaymentSlip from '@/views/financial/ToExpirePaymentSlip';
import LatePaymentSlip from '@/views/financial/LatePaymentSlip';
import AnticipationPaymentSlip from '@/views/financial/AnticipationPaymentSlip';
import BankFinancing from '@/views/financial/BankFinancing';
import Bulletins from '@/views/Bulletins';
import Profile from '@/views/Profile';
import AdminPreview from '@/views/AdminPreview';
import SelectUnit from '@/views/SelectUnit';
import SyndicSelectProduct from '@/views/SyndicSelectProduct';
import Home from '@/views/Home';
import SlipUnavailable from '@/views/SlipUnavailable';
import SlipPreview from '@/views/SlipPreview';
import NewsHappen from '@/views/news/Happen';
import NewsIframe from '@/views/news/Iframe';
import InspectionDetails from '@/views/support/inspection/InspectionDetails';
import Reschedule from '@/views/support/ticket/technicalAssistance/RescheduleTicket';
import Appointment from '@/views/support/Appointment';
import Credits from '@/views/app/Credits';
import BlockadeWarning from '@/views/app/BlockadeWarning';

import { PROFILES, ROLES, EVENTS, MODULES } from '../utils/constants';
import store from '../store';
const {
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
  FINANCIAL_PROFILE,
  ADMIN_FINANCIAL_PROFILE
} = PROFILES;

export default [
  {
    path: '/acesso',
    name: 'login',
    component: Login,
    meta: {
      module: MODULES.AUTH,
      requiresAuth: false
    }
  },
  {
    path: '/esqueci-minha-senha',
    name: 'forgotPassword',
    component: ForgotPassword,
    meta: {
      module: MODULES.AUTH,
      requiresAuth: false,
      userRole: ROLES.CLIENT_ROLE
    }
  },
  {
    path: '/sindico/esqueci-minha-senha',
    name: 'syndicForgotPassword',
    component: ForgotPassword,
    meta: {
      module: MODULES.AUTH,
      requiresAuth: false,
      userRole: ROLES.SYNDIC_ROLE
    }
  },
  {
    path: '/novasenha',
    name: 'resetPassword',
    component: ResetPassword,
    meta: {
      module: MODULES.AUTH,
      requiresAuth: false,
      userRole: ROLES.CLIENT_ROLE
    }
  },
  {
    path: '/alteraremail',
    name: 'changeRepeatedEmail',
    component: ChangeRepeatedEmail,
    meta: {
      module: MODULES.AUTH,
      requiresAuth: true,
      userRole: ROLES.CLIENT_ROLE
    }
  },
  {
    path: '/sindico/novasenha',
    name: 'syndicResetPassword',
    component: ResetPassword,
    meta: {
      module: MODULES.AUTH,
      requiresAuth: false,
      userRole: ROLES.SYNDIC_ROLE
    }
  },
  {
    path: '/selecionar-unidade',
    name: 'selectUnit',
    component: SelectUnit,
    meta: {
      module: MODULES.UNIT,
      requiresAuth: true,
      profiles: []
    }
  },
  {
    path: '/sindico/selecionar-empreendimento',
    name: 'syndicSelectProduct',
    component: SyndicSelectProduct,
    meta: {
      module: MODULES.UNIT,
      requiresAuth: true,
      profiles: []
    }
  },
  {
    path: '/documentos',
    children: [
      {
        path: 'geral',
        name: 'generalDocuments'
      },
      {
        path: 'legal',
        name: 'legalDocuments'
      }
    ],
    component: EnterpriseDocuments,
    meta: {
      module: MODULES.DOCUMENT,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },

  {
    path: '/documentos',
    children: [
      {
        path: 'proprietario',
        name: 'ownerDocuments'
      }
    ],
    component: ProductDocuments,
    meta: {
      module: MODULES.DOCUMENT,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },

  {
    path: '/documentos',
    children: [
      {
        path: 'sindico',
        name: 'syndicDocuments'
      }
    ],
    component: SyndicDocuments,
    meta: {
      module: MODULES.DOCUMENT,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },

  {
    path: '/empreendimento/meu-empreendimento',
    name: 'myEnterprise',
    component: MyEnterprise,
    meta: {
      module: MODULES.ENTERPRISE,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/empreendimento/decorado',
    name: 'myDecorated',
    component: MyDecorated,
    meta: {
      module: MODULES.ENTERPRISE,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/empreendimento/acompanhe-as-obras',
    name: 'constructionProgress',
    component: ConstructionProgress,
    meta: {
      module: MODULES.ENTERPRISE,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/empreendimento/parceriasedescontos',
    name: 'discountList',
    component: DiscountList,
    meta: {
      module: MODULES.ENTERPRISE,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/atendimento/solicitacao/nova',
    name: 'ticketForm',
    component: TicketForm,
    meta: {
      module: MODULES.TICKET_CRM,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/atendimento/solicitacao/detalhes/:number',
    name: 'ticketDetails',
    component: TicketDetails,
    meta: {
      module: MODULES.TICKET_CRM,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },

  {
    path: '/atendimento/solicitacao/consulta',
    name: 'ticketList',
    component: TicketList,
    meta: {
      module: MODULES.TICKET_CRM,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/atendimento/solicitacao/detalhe/:ticketId',
    name: 'appointmentDetail',
    component: AppointmentDetail,
    meta: {
      module: MODULES.TICKET_CRM,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/atendimento/solicitacao/vistoria',
    name: 'inspectionDetails',
    component: InspectionDetails,
    beforeEnter: (to, from, next) => {
      if (store.getters[EVENTS.GET_INSPECTION] == null) {
        next({
          name: 'appointments'
        });
      } else {
        next();
      }
    },
    meta: {
      module: MODULES.SUPPORT,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/atendimento/solicitacao/reagendar/:ticketId',
    name: 'reschedule',
    component: Reschedule,
    meta: {
      module: MODULES.TICKET_CRM,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/atendimento/solicitacao/ouvidoria',
    name: 'ombudsmanForm',
    component: OmbudsmanForm,
    meta: {
      module: MODULES.TICKET_CRM,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/atendimento/agendamento/entrega-de-chaves',
    name: 'keyDeliverySchedule',
    component: KeyDeliverySchedule,
    meta: {
      module: MODULES.SUPPORT,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/comunicados',
    name: 'bulletins',
    component: Bulletins,
    meta: {
      module: MODULES.BULLETIN,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/financeiro/posicao-financeira',
    name: 'financialPosition',
    component: FinancialPosition,
    meta: {
      module: MODULES.FINANCIAL,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE,
        FINANCIAL_PROFILE,
        ADMIN_FINANCIAL_PROFILE
      ]
    }
  },
  {
    path: '/financeiro/informe-de-rendimentos',
    name: 'incomeReport',
    component: IncomeReport,
    meta: {
      module: MODULES.FINANCIAL,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE,
        FINANCIAL_PROFILE,
        ADMIN_FINANCIAL_PROFILE
      ]
    }
  },
  {
    path: '/financeiro/boletos/proximo-vencimento',
    name: 'toExpirePaymentSlip',
    component: ToExpirePaymentSlip,
    meta: {
      module: MODULES.PAYMENT_SLIPS,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE,
        FINANCIAL_PROFILE,
        ADMIN_FINANCIAL_PROFILE
      ]
    }
  },
  {
    path: '/financeiro/boletos/atraso',
    name: 'latePaymentSlip',
    component: LatePaymentSlip,
    meta: {
      module: MODULES.PAYMENT_SLIPS,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE,
        FINANCIAL_PROFILE,
        ADMIN_FINANCIAL_PROFILE
      ]
    }
  },
  {
    path: '/financeiro/boletos/antecipacao',
    name: 'anticipationPaymentSlip',
    component: AnticipationPaymentSlip,
    meta: {
      module: MODULES.PAYMENT_SLIPS,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE,
        FINANCIAL_PROFILE,
        ADMIN_FINANCIAL_PROFILE
      ]
    }
  },
  {
    path: '/financeiro/financiamento-bancario',
    name: 'bankFinancing',
    component: BankFinancing,
    meta: {
      module: MODULES.FINANCIAL,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE,
        FINANCIAL_PROFILE,
        ADMIN_FINANCIAL_PROFILE
      ]
    }
  },
  {
    path: '/cadastro',
    name: 'profile',
    component: Profile,
    meta: {
      module: MODULES.PROFILE,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/cadastro/senha',
    name: 'profilePassword',
    component: Profile,
    meta: {
      module: MODULES.PROFILE,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/atendimento/perguntas-frequentes',
    name: 'faq',
    component: Faq,
    meta: {
      module: MODULES.SUPPORT,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      module: 'home',
      requiresAuth: true,
      profiles: []
    }
  },
  {
    path: '/adminpreview/',
    component: AdminPreview,
    name: 'adminPreview',
    meta: {
      module: 'adminPreview',
      requiresAuth: false
    }
  },
  {
    path: '/boleto-indisponivel',
    component: SlipUnavailable,
    name: 'slipUnavailablePage',
    meta: {
      module: 'slipUnavailable',
      requiresAuth: true
    }
  },
  {
    path: '/boleto/:q',
    component: SlipPreview,
    name: 'slipPreviewPage',
    meta: {
      module: 'slipPreview',
      requiresAuth: false
    }
  },
  {
    path: '/noticias/aconteceu',
    name: 'newsHappen',
    component: NewsHappen,
    meta: {
      module: MODULES.NEWS,
      requiresAuth: true,
      profiles: []
    }
  },
  {
    path: '/noticias/:type',
    name: 'newsIframe',
    component: NewsIframe,
    meta: {
      module: MODULES.NEWS,
      requiresAuth: true,
      profiles: []
    }
  },
  {
    path: '/creditos',
    name: 'credits',
    component: Credits,
    meta: {
      module: MODULES.APP,
      requiresAuth: false,
      profiles: []
    }
  },
  {
    path: '/aviso',
    name: 'blockadeWarning',
    component: BlockadeWarning,
    meta: {
      module: MODULES.APP,
      requiresAuth: false,
      profiles: []
    }
  },
  {
    path: '/atendimento/meus-compromissos',
    name: 'appointments',
    component: Appointment,
    meta: {
      module: MODULES.SUPPORT,
      requiresAuth: true,
      profiles: [
        ADMIN_PROFILE,
        ADMIN_BEXS_PROFILE,
        ADMIN_HR_PROFILE,
        HR_PROFILE
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/routes.js